import { heroData, ctaLink } from "../data/mock";
import { ArrowRight, Clock, Zap } from "lucide-react";

export const HeroSection = () => {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center overflow-hidden"
      style={{ background: "#1a1c1b" }}
    >
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src={heroData.backgroundImage}
          alt=""
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(135deg, rgba(26,28,27,0.95) 0%, rgba(26,28,27,0.85) 50%, rgba(26,28,27,0.68) 100%)",
          }}
        />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-[87.5rem] mx-auto px-10 w-full py-40">
        <div className="max-w-3xl">
          {/* Eyebrow */}
          <div className="mb-8">
            <span
              className="inline-block text-[#888680] text-xs font-medium uppercase tracking-[0.2em] border border-[#3f4816]/40 px-4 py-2 rounded-full"
              style={{ fontFamily: "'Inter', Arial, sans-serif" }}
            >
              Cross-Border Tax & Business Advisory
            </span>
          </div>

          {/* Headline — NRI and Founder highlighted distinctly */}
          <h1
            className="font-black uppercase leading-[0.88] mb-8"
            style={{
              fontFamily: "'Inter', Arial, sans-serif",
              fontSize: "clamp(2.8rem, 2.2rem + 3vw, 5rem)",
              letterSpacing: "-0.02em",
            }}
          >
            <span className="text-[#dfddd6]">Stop </span>
            <span className="text-[#d9fb06]">Overpaying Taxes</span>
            <br />
            <span className="text-[#888680]/60">as an </span>
            <span
              className="relative"
              style={{
                color: "#ffffff",
                borderBottom: "2px solid rgba(255,255,255,0.25)",
                paddingBottom: "2px",
              }}
            >
              NRI
            </span>
            <span className="text-[#888680]/60"> or </span>
            <span
              className="relative"
              style={{
                color: "#ffffff",
                borderBottom: "2px solid rgba(255,255,255,0.25)",
                paddingBottom: "2px",
              }}
            >
              Founder
            </span>
            <span className="text-[#888680]/60">.</span>
          </h1>

          {/* Subheadline */}
          <p
            className="text-[#888680] text-base leading-relaxed mb-10 max-w-xl"
            style={{
              fontFamily: "'Inter', Arial, sans-serif",
              fontWeight: 400,
            }}
          >
            Losing lakhs to missed{" "}
            <span className="text-[#dfddd6] font-medium">DTAA benefits</span>,
            wrong TDS, and the{" "}
            <span className="text-[#dfddd6] font-medium">
              wrong business structure
            </span>
            ? One cross-border strategy fixes all of it.
          </p>

          {/* CTA */}
          <a
            href="#final-cta"
            className="group bg-[#d9fb06] text-[#1a1c1b] font-semibold text-sm px-8 py-4 rounded-full transition-all duration-300 hover:scale-[1.02] hover:opacity-90 active:scale-[0.98] uppercase tracking-tight inline-flex items-center gap-3"
            style={{ fontFamily: "'Inter', Arial, sans-serif" }}
          >
            {heroData.ctaText}
            <ArrowRight
              size={16}
              className="transition-transform duration-300 group-hover:translate-x-1"
            />
          </a>

          {/* CTA Subtext */}
          <div className="mt-6 flex flex-wrap items-center gap-6">
            <span className="flex items-center gap-2 text-[#888680] text-xs">
              <Clock size={13} className="text-[#3f4816]" />
              30 min · Paid session
            </span>
            <span className="flex items-center gap-2 text-[#888680] text-xs">
              <Zap size={13} className="text-[#3f4816]" />
              Leave with a clear action plan
            </span>
          </div>
        </div>
      </div>

      {/* Bottom gradient fade */}
      <div
        className="absolute bottom-0 left-0 right-0 h-32"
        style={{
          background: "linear-gradient(to top, #1a1c1b 0%, transparent 100%)",
        }}
      />
    </section>
  );
};
